import Attrs from '../../models/Attrs'
import type { FlowPage, OptionSelector } from '../../models/types'

export default function renderPageSubtitle(
  component: OptionSelector,
  attrs: Attrs,
  page: FlowPage
): string {
  const inPageClasses = [
    `in-page-key-${page.key}`,
    ...(page.tags || []).map((tag) => `in-page-tag-${tag}`),
  ]
  attrs.addDOMClass(['subtitle', ...inPageClasses])
  attrs.addController('template')
  return `<div ${attrs}>${page.subtitle || ''}</div>`
}
